import { IdTokenResult } from "@angular/fire/auth";

export const isAdmin = (credential: IdTokenResult): boolean => credential.claims['isAdmin'] === true || credential.claims['isEditor'] === true;
